// v3/app/router/ProtectedRoute.tsx — Auth guard
// Checks isAuthenticated from auth store.
// Redirects to /v3/login if not authenticated.
// Renders Outlet if authenticated.
// Zero imports from v1/v2.

import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuthStore } from '../../shared/stores/auth-store';

export function ProtectedRoute() {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <Outlet />;
}
